<template>
  <div class="dashboardContainer">
    <el-row :gutter="24" v-for="(row, index) in rows" :key="index">
      <div v-for="(item, intemIndex) in functions" :key="intemIndex">
        <el-col
          :span="4"
          v-if="
            intemIndex >= index * columns && intemIndex < (index + 1) * columns
          "
        >
          <div class="cardContainer" @click="clickMenu(item.path)">
            <div class="card-title">
              <label class="main-title">{{ item.name }}</label>
              <label class="sub-title">{{ item.englishName }}</label>
            </div>
            <div :class="item.icon"></div>
          </div>
        </el-col>
      </div>
    </el-row>
  </div>
</template>

<script>
export default {
  name: "Dashboard",
  data() {
    return {
      rows: 0, //功能行数
      columns: 6, //每行包含的功能数
    };
  },
  mounted() {
    this.initPage();
  },
  props: ["functions"],
  methods: {
    initPage() {
      if (this.functions && this.functions.length > 0) {
        let len = this.functions.length;
        this.rows = Math.ceil(len / this.columns);
      }
    },
    clickMenu(type) {
      this.$emit("handleSubMenuSelect", type);
    },
  },
};
</script>

<style scoped>
.dashboardContainer {
  width: 100%;
  height: 100%;
}
.dashboardContainer .el-row,
.dashboardContainer .el-row .el-col {
  height: 80px;
}
.dashboardContainer .el-row {
  margin-top: 20px;
  margin-left: -8px !important;
  margin-right: -8px !important;
}
.dashboardContainer .el-row .el-col {
  padding-left: 8px !important;
  padding-right: 8px !important;
}
.cardContainer {
  height: 40px;
  padding: 22px 20px 18px 19px;
  background: rgba(20, 107, 249, 0.1);
  border: 1px solid #146bf9;
  box-shadow: 0px 3px 9px 0px rgba(0, 0, 0, 0.08);
  border-radius: 6px;
  cursor: pointer;
}

.cardContainer:hover {
  background: #0083fd;
}

.cardContainer .card-title {
  float: left;
}
.cardContainer [class^="card-icon-"] {
  height: 40px;
  width: 40px;
  float: right;
}

.card-title {
  height: 100%;
  width: calc(100% - 40px);
}
.card-title label {
  width: 100%;
  float: left;
  text-align: left;
  cursor: pointer;
}

.main-title {
  cursor: pointer;
  height: 16px;
  font-size: 16px;
  font-family: AlibabaPuHuiTiM;
  font-weight: 500;
  color: #ffffff;
  line-height: 16px;
}

.cardContainer:hover .main-title {
  color: #ffffff;
}

.sub-title {
  height: 9px;
  font-size: 9px;
  font-family: ArialMT;
  font-weight: 400;
  color: #dadada;
  line-height: 9px;
  margin-top: 5px;
}

.card-icon-user {
  background: url("../../assets/img/admin/userListCard.png");
}
.cardContainer:hover .card-icon-user {
  background: url("../../assets/img/admin/userListCardHover.png");
}
.card-icon-depart {
  background: url("../../assets/img/admin/departmentCard.png");
}
.cardContainer:hover .card-icon-depart {
  background: url("../../assets/img/admin/departmentCardHover.png");
}
.card-icon-permission {
  background: url("../../assets/img/admin/permissionCard.png");
}
.cardContainer:hover .card-icon-permission {
  background: url("../../assets/img/admin/permissionCardHover.png");
}
.card-icon-role {
  background: url("../../assets/img/admin/roleCard.png");
}
.cardContainer:hover .card-icon-role {
  background: url("../../assets/img/admin/roleCardHover.png");
}
.card-icon-area {
  background: url("../../assets/img/admin/areaCard.png");
}
.cardContainer:hover .card-icon-area {
  background: url("../../assets/img/admin/areaCardHover.png");
}
.card-icon-station {
  background: url("../../assets/img/admin/stationCard.png");
}
.cardContainer:hover .card-icon-station {
  background: url("../../assets/img/admin/stationCardHover.png");
}
.card-icon-airport {
  background: url("../../assets/img/admin/airportCard.png");
}
.cardContainer:hover .card-icon-airport {
  background: url("../../assets/img/admin/airportCardHover.png");
}
.card-icon-takeoff {
  background: url("../../assets/img/admin/takeOffCard.png");
}
.cardContainer:hover .card-icon-takeoff {
  background: url("../../assets/img/admin/takeOffCardHover.png");
}
.card-icon-company {
  background: url("../../assets/img/admin/companyCard.png");
}
.cardContainer:hover .card-icon-company {
  background: url("../../assets/img/admin/companyCardHover.png");
}
.card-icon-planetype {
  background: url("../../assets/img/admin/planeTypeCard.png");
}
.cardContainer:hover .card-icon-planetype {
  background: url("../../assets/img/admin/planeTypeCardHover.png");
}
.card-icon-plane {
  background: url("../../assets/img/admin/planeCard.png");
}
.cardContainer:hover .card-icon-plane {
  background: url("../../assets/img/admin/planeCardHover.png");
}
.card-icon-key {
  background: url("../../assets/img/admin/keyCard.png");
}
.cardContainer:hover .card-icon-key {
  background: url("../../assets/img/admin/keyCardHover.png");
}

.card-icon-link {
  background: url("../../assets/img/admin/linkCard.png");
}
.cardContainer:hover .card-icon-link {
  background: url("../../assets/img/admin/linkCardHover.png");
}

.card-icon-com-station {
  background: url("../../assets/img/admin/comStationCard.png");
}
.cardContainer:hover .card-icon-com-station {
  background: url("../../assets/img/admin/comStationCardHover.png");
}

.card-icon-element {
  background: url("../../assets/img/admin/elementManagement.png");
}
.cardContainer:hover .card-icon-element {
  background: url("../../assets/img/admin/elementManagementHover.png");
}

.card-icon-historical-task {
  background: url("../../assets/img/admin/historicalTask.png");
}
.cardContainer:hover .card-icon-historical-task {
  background: url("../../assets/img/admin/historicalTaskHover.png");
}

.card-icon-flight-record {
  background: url("../../assets/img/admin/flightRecord.png");
}
.cardContainer:hover .card-icon-flight-record {
  background: url("../../assets/img/admin/flightRecordHover.png");
}

.card-icon-video-data {
  background: url("../../assets/img/admin/videoData.png");
}
.cardContainer:hover .card-icon-video-data {
  background: url("../../assets/img/admin/videoDataHover.png");
}

.card-icon-data-statistics {
  background: url("../../assets/img/admin/dataStatistics.png");
}
.cardContainer:hover .card-icon-data-statistics {
  background: url("../../assets/img/admin/dataStatisticsHover.png");
}
</style>



// WEBPACK FOOTER //
// src/components/admin/dashboard.vue